var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Your current role is "),_c('strong',[_vm._v("1")]),_vm._v(".")]),_c('h4',[_vm._v("You are in home.")])])}]

export { render, staticRenderFns }